import React from 'react';

import { Divider, Space } from 'antd';
import {
  Notification,
  SelectOption,
  Column,
  Text,
  Select,
  PlusOutlined,
  Button,
  ButtonType,
  PlusCircleFilled,
} from 'farmhub-ui-core';

import { useAppDispatch } from 'app';
import { CButton } from 'components';
import { filterEntityLarkApp, findZaloOAWWithEntity } from 'slice';
import { formatPhoneNumber, isVietnamesePhoneNumber } from 'utils';

import { SelectCustom } from './styles';

type LarkAppSelectProps = {
  selectedEntityLarkApp?: any;
  selectedID?: string;
  entityID?: any;
  disabled?: boolean;
  isLoading?: boolean;
  onSelect?: (val?: any) => void;
  onAddLarkApp?: () => void;
};

const LarkAppSelect = ({
  selectedID,
  entityID,
  disabled = false,
  selectedEntityLarkApp,
  isLoading = false,
  onSelect,
  onAddLarkApp,
}: LarkAppSelectProps) => {
  const dispatch = useAppDispatch();
  const [entityLarkApp, setEntityLarkApp] = React.useState<any[]>([]);
  const [isLoadingEntityLarkApp, setIsLoadingEntityZaloOA] =
    React.useState(true);

  const [query, setQuery] = React.useState({
    entityIDs: [entityID],
    take: 10,
    page: 1,
  });

  const [totalLarkApp, selectTotalLarkApp] = React.useState<number>(0);

  React.useEffect(() => {
    const getEntityLarkAppWithEntity = async () => {
      try {
        const { data, pagination }: any = await dispatch(
          filterEntityLarkApp(query)
        ).unwrap();

        setEntityLarkApp((prevState: any) => [...prevState, ...data]);
        selectTotalLarkApp(pagination.total);
      } catch (error) {
        Notification('error', 'Tải ứng dụng Lark thất bại');
      }
    };

    const getData = setTimeout(() => {
      if (entityID) {
        getEntityLarkAppWithEntity();
      }
    }, 800);

    return () => clearTimeout(getData);
  }, [dispatch, query, entityID]);

  const handleSearch = (value): void => {
    setEntityLarkApp([]);
    setQuery((prevState: any) => {
      return {
        ...prevState,
        page: 1,
        name: isVietnamesePhoneNumber(value?.trim())
          ? formatPhoneNumber(value)
          : value?.replace(/\s+/g, ' ').trim(),
      };
    });
  };

  const handleLoadMore = () => {
    setQuery((prevState: any) => {
      return {
        ...prevState,
        page: query.page + 1,
      };
    });
  };

  const handleScroll = e => {
    const isEndOfList =
      e.target.scrollTop >
      (4 / 5) * (e.target.scrollHeight - e.target.offsetHeight);

    if (
      isEndOfList &&
      !isLoadingEntityLarkApp &&
      entityLarkApp.length < totalLarkApp
    ) {
      handleLoadMore();
    }
  };

  const handleSelect = (val: any) => {
    onSelect && onSelect(val);
  };

  React.useEffect(() => {
    if (entityID) {
      setQuery({
        entityIDs: [entityID],
        take: 10,
        page: 1,
      });
    }
  }, [entityID]);

  return (
    <SelectCustom
      allowClear
      showSearch
      disabled={disabled}
      dropdownRender={menu => (
        <>
          {menu}
          <Divider style={{ margin: '8px 0' }} />
          <Space style={{ padding: '0 8px 4px' }}>
            <CButton
              ghost
              height="sm"
              type={ButtonType.Primary}
              width="160px"
              onClick={onAddLarkApp}
            >
              Thêm ứng dụng Lark
            </CButton>
          </Space>
        </>
      )}
      filterOption={false}
      height="42px"
      optionLabelProp="label"
      placeholder="Chọn ứng dụng Lark"
      value={isLoading ? '' : selectedID}
      width="100%"
      onChange={(val: any) => handleSelect(val)}
      onPopupScroll={(e: any) => handleScroll(e)}
      onSearch={(val: string) => handleSearch(val)}
    >
      {(selectedEntityLarkApp
        ? [selectedEntityLarkApp, ...entityLarkApp]
        : [...entityLarkApp]
      ).map((item: any) => (
        <SelectOption key={item?.id} label={item?.name} value={item?.id}>
          <Column>
            <Text size="xxs">{item?.name}</Text>
            <Text color="main" size="tiny">
              {item?.appID}
            </Text>
          </Column>
        </SelectOption>
      ))}

      {/* <Space style={{ padding: '0 8px 4px' }}>
        <Button
          type="text"
          icon={<PlusOutlined />}
          onClick={() => alert('hello')}
        >
          Add item
        </Button>
      </Space> */}
    </SelectCustom>
  );
};

export default LarkAppSelect;
